/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 文字列関連ユーティリティ
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
export default new class {
  /**
   * 文字列のバイト数を取得します。
   * @param  {String} string 文字列
   * @param  {String} encoding エンコード（未指定の場合はutf8）
   * @return {integer} バイト数
   */
  getByteLength(string, encoding) {
    encoding = encoding || 'utf8'
    return Buffer.byteLength(string, encoding)
  }
  /**
   * 文字列中のURL（http）をアンカーリンクでマークアップします
   * @param  {string} value URLを含む文章
   * @return {string} URL部分をマークアップした文章全体
   */
  getHtmlTextMarkUpHttpURL(value) {
    let dispValue = value
    if (value != null && typeof value === 'string') {
      // 特殊文字をエスケープ
      dispValue = value.replace(/[&"'<>]/g, function (m) {
          return '&' + ['amp', 'quot', '#039', 'lt', 'gt']['&"\'<>'.indexOf(m)] + ';'
      })
      let beforeDispValue = dispValue
      // DocsBotのアンカーリンク（[xxx](https://xxx)）があればアンカーリンクの置換を行う
      dispValue = dispValue.replace(/\[([^\]]+)]\(([^)]+)\)/g, function(match, text, url) {
        return '<a href="' + url + '" target="_blank">[' + text + ']</a>'
      })
      // DocsBotのアンカーリンク（[xxx](https://xxx)）の変換なければ通常のアンカーリンクの置換を行う
      if (beforeDispValue === dispValue) {
        // アンカーリンクをマークアップ
        dispValue = dispValue
          .replace(new RegExp('(https?:\\/\\/[^\\s)]+)|(\\\\[^　\\s\\:\\*\\?\\"<>\\|\\#\\{\\}\\%\\&\\~]+)|(&lt;\\\\[^　\\s\\:\\*\\?\\"<>\\|\\#\\{\\}\\%\\&\\~]+&gt;)', 'gi'), '<a href="$&" target="_blank"><font color="#0000ff"><u>$&</u></font></a>')
        dispValue = this.convertNewLineToBrTag(dispValue)
      }
    }
    return dispValue
  }
  /**
   * NewLineを&lt;br&gt;タグに変換 します。
   * @param {string} value 対象文字
   * @return string
   */
  convertNewLineToBrTag(value) {
    if (value != null && typeof value === 'string') {
      value = value.replace(/\n/g, '<br />')
    }
    return value
  }
  /**
   * 対象文字列に指定のパターンが含まれているかチェック
   * @param {string} value 対象文字
   * @param {string} pattern 検索パターン
   * @return string
   */
  isContainsRegExpPattern(value, pattern) {
    if (this.isBlank(value) || this.isBlank(pattern)) {
      return false
    }
    if (value.search(pattern) !== -1) {
      return true
    }
    return false
  }
  /**
   * 文字列が null or empty("") or whitespace かチェック
   * fhStringUtil.isBlank(null) = true
   * fhStringUtil.isBlank("") = true
   * fhStringUtil.isBlank(" ") = true
   * fhStringUtil.isBlank(" ") = true
   * fhStringUtil.isBlank("bob") = false
   * fhStringUtil.isBlank(" bob ") = false
   *
   * @param {string} str チェック文字列
   * @return {boolean} true or false
   */
  isBlank(str) {
    if (str == null) {
      return true
    }
    if (str.trim() === '') {
      return true
    }
    return false
  }
  /**
   * 文字列の末尾が、サフィックス一覧のいずれかに該当するか
   *
   * @param {string}
   *            str チェック文字列
   * @param {Array[string]}
   *            suffixList サフィックス一覧
   * @param {boolean}
   *            ignoreCase 大文字小文字は判別しないか
   * @param {boolean}
   *            trimSuffix サフィックスをトリムするか
   * @return {boolean} true or false
   */
  endWithSuffixList(str, suffixList, ignoreCase, trimSuffix) {
    str = str || ''
    suffixList = suffixList || []
    if (ignoreCase) {
      str = str.toLowerCase()
    }
    return suffixList.some(function (suffix) {
      if (ignoreCase) {
        suffix = suffix.toLowerCase()
      }
      if (trimSuffix) {
        suffix = suffix.trim()
      }
      console.log(str, suffix, str.endsWith(suffix))
      return str.endsWith(suffix)
    })
  }
  /**
   * 文字列の末尾が、サフィックス一覧のいずれかに該当するか
   *
   * @param {string}
   *            str チェック文字列
   * @param {string}
   *            suffixListCsv サフィックス一覧のCSV
   * @param {boolean}
   *            ignoreCase 大文字小文字は判別しないか
   * @param {boolean}
   *            trimSuffix サフィックスをトリムするか
   * @return {boolean} true or false
   */
  endWithSuffixListCsv(str, suffixListCsv, ignoreCase, trimSuffix) {
    suffixListCsv = suffixListCsv || ''
    const suffixList = suffixListCsv.split(',')
    return this.endWithSuffixList(str, suffixList, ignoreCase, trimSuffix)
  }
}()



// WEBPACK FOOTER //
// ./src/utils/StringUtil.js